module.exports = __webpack_public_path__ + "img/CarGroupFunctionPage.25093b26.png";